import { DeliveryContainerContentsDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { DeliveryContainerHistoricalContentsModel } from './delivery-container-historical-content.model';

export class DeliveryContainerContentsModel extends DeliveryContainerHistoricalContentsModel {
  usageType: string;

  constructor(dto: DeliveryContainerContentsDto) {
    super(dto);
    this.usageType = dto.usageType;
  }
}
